import { UntypedFormControl } from '@angular/forms';

export class JSONSyntaxValidator {
  public static invalidJson(jsonFormCtrl: UntypedFormControl) {
    if (jsonFormCtrl.value) {
      try {
        JSON.parse(jsonFormCtrl.value);
      } catch (err) {
        return { syntax: true };
      }
    }
    return null;
  }
}
